/* ZCanvasFunct
Versione 1.0.0 - 07 Novembre 2023 - Massimiliano Zirilli
                 - Prima versione
*/

export class TZCanvasFunct
{
  static WriteVerticalString(Context,X,Y,Caption,Stroke = false,BottomToRight = true)
  {
    Context.save();
    Context.translate(X,Y)
    if(BottomToRight)
        Context.rotate(-Math.PI / 2)
    else Context.rotate(Math.PI / 2)    
    Context.fillText(Caption,0,0)
    Context.restore()
  }
   
}
